<template>
    <ListDialog title="Selecione um ponto de venda"
                :search-keys="['CD_Ponto_Venda', 'NM_Ponto_Venda']"
                :item-text="descricaoPontoVenda"
                :items="items"
                :show-close-button="showCloseButton"
                v-bind="$attrs"
                v-on="$listeners" />
</template>

<script>
  export default {
    name: 'DialogPontosVenda',
    props: { items: Array, showCloseButton: Boolean },
    methods: {
      descricaoPontoVenda (item) {
        return `${item['CD_Ponto_Venda']} - ${item['NM_Ponto_Venda']}`
      }
    }
  }
</script>

<style scoped>

</style>
